export const realtorData = {
  email: 'TEOTAIPROPIEDADES@UNNE.CL',
  phone:'926380128'
};
